import Auth from '../../../../../auth';
import multiPickerTemplate from '../../../../../components/assetpicker/asset.multi.picker.html';

export default function GeozonesCreateController(
  $window,
  $scope,
  $timeout,
  $uibModal,
  $state,
  equipmentGeozoneService,
  gettextCatalog,
) {
  'ngInject';

  $scope.numSelectedAsset = 0;
  $scope.selectedAsset = {};
  $scope.maxEmails = 10;
  $scope.errorOccured = false;
  $scope.existingGeozoneMsg = '';
  $scope.geozoneNameExists = false;
  $scope.geozoneRequired = false;
  $scope.sending = false;
  $scope.validNameCharacters = '[a-zA-Z0-9\\_\\-\\(\\) ]*';

  $scope.$on('totalEmails', function (event, totalEmails) {
    $scope.maxEmails = totalEmails.length;
  });

  $scope.isFormValid = function (createGeoZoneForm) {
    createGeoZoneForm.$setSubmitted();
    $scope.geozoneRequired = $scope.geozone.geometry === '';

    if (createGeoZoneForm.$invalid) {
      $scope.loading = false;
      return;
    }
    $scope.submitGeozoneForm();
  };

  $scope.addAssetsButtonSelected = function () {
    var modalInstance = $uibModal.open({
      animation: true,
      template: multiPickerTemplate,
      controller: 'AssetMultiPickerController',
      resolve: {
        singleSelect: false,
        requiresSelection: true,
        maxSelection: function () {
          return 0;
        },
        selectedAssets: function () {
          var selected = {};

          if ($scope.assets) {
            for (var i = 0; i < $scope.assets.length; i++) {
              var e = $scope.assets[i];
              selected[e.id] = e;
            }
          }
          return selected;
        },
      },
      size: 'lg',
    });
    modalInstance.result.then(
      function (selectedAssets) {
        $scope.$on('$locationChangeStart', function (event, next, current) {
          // Here you can take the control and call your own functions:
          event.preventDefault();
        });
        $scope.equipmentDict = selectedAssets.result;
        $scope.numSelectedAsset = Object.keys($scope.equipmentDict).length;
        for (var key in $scope.equipmentDict) {
          if ($scope.equipmentDict.hasOwnProperty(key)) {
            $scope.assets.push($scope.equipmentDict[key]);
          }
        }
      },
      function (error) {},
    );
  };

  $scope.assets = [];
  $scope.submitGeozoneForm = function () {
    $scope.errorOccured = false;
    $scope.geozoneRequired = false;
    if ($scope.tags.length > 0) {
      for (var i = 0; i < $scope.tags.length; i++) {
        $scope.geozone.tags.push($scope.tags[i].text.toLowerCase());
      }
    }
    // only post if form info is valid
    if ($scope.createGeoZoneForm.$valid == true) {
      if ($scope.geozone.alertRule.contacts.length <= $scope.maxEmails) {
        $scope.sending = true;
        equipmentGeozoneService.getGeozoneByName($scope.geozone.name).then(
          function (response) {
            $scope.sending = false;
            showGeoZoneNameError();
          },
          function (error) {
            if (error.status == 404) {
              saveNewGeozone();
            } else {
              $scope.sending = false;
              $scope.errorOccured = true;
              var errorMsg = gettextCatalog.getString(
                'An error occurred while creating the GeoZone',
              );
              if ((error.data || error.status) && !error.status == 404) {
                if (error.data.message) {
                  errorMsg = error.data.message + ' ' + error.status.toString();
                } else {
                  errorMsg += ': ' + error.status.toString();
                }
              } else {
                errorMsg += gettextCatalog.getString('. Please try again later.');
              }
              $scope.errorText = errorMsg;
            }
          },
        );
      }
    }
  };

  function showGeoZoneNameError(response) {
    $scope.geozoneNameExists = true;
    $scope.existingGeozoneMsg = gettextCatalog.getString(
      "The name '{{ gname}}' already exists. Please rename the GeoZone. ",
      {
        gname: $scope.geozone.name,
      },
    );
  }

  function saveNewGeozone() {
    $scope.geozoneNameExists = false;
    $scope.geozone.equipmentIds = Object.keys($scope.equipmentDict);
    equipmentGeozoneService.postNewEquipmentGeozone($scope.geozone).then(
      function (response) {
        $scope.sending = false;
        $timeout(function () {
          $state.go('alerts.geozone.details', {
            geozoneId: response.data.id,
          });
        }, 0);
        return;
        //return equipmentGeozoneService.addEquipmentInZone($scope.geozoneid, Object.keys($scope.equipmentDict));
      },
      function (error) {
        $scope.sending = false;
        $scope.errorOccured = true;
        var errorMsg = gettextCatalog.getString('An error occurred while creating the GeoZone');
        if (error.data || error.status) {
          if (error.data.message) {
            errorMsg = error.data.message + ' ' + error.status.toString();
          } else {
            errorMsg += ': ' + error.status.toString();
          }
        } else {
          errorMsg += gettextCatalog.getString('. Please try again later.');
        }
        $scope.errorText = errorMsg;
      },
    );
  }

  var init = function () {
    //init the form
    $scope.tags = [];
    $scope.emails = null;
    //default geozone model
    $scope.geozone = {
      name: '',
      description: '',
      type: 'Exclusive', //default, no UI for this
      tags: [],
      attrs: {
        color: '#0c0', //default geozone color to green
      },
      geometry: '',
      alertRule: {
        contacts: [],
        priority: '',
        notifyOnActive: 'false', //default
        notifyOnReturn: 'false', //default
        autoclear: 'Immediately', //default, no UI for this
        brand: Auth.getBrandClaim(),
      },
    };
    $scope.geozone.alertRule.contacts = [];
    $scope.geozone.alertRule.notifyOnActive = false;
    $scope.geozone.alertRule.notifyOnReturn = false;
    $scope.geozoneRequired = false;
  };
  init();
}
